import { useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { InvitedNotLoggedStudentApi, invitedStudentsApi } from "./invitedStudentsApi";

export const useInvitedStudents = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.INVITED_STUDENTS(),
    queryFn: () => invitedStudentsApi.fetch(),
    select: (apiData) =>
      apiData?.data?.map(
        (student: InvitedNotLoggedStudentApi): InvitedNotLoggedStudentData => ({
          id: student.userId,
          email: student.email,
          lastEmailSent:
            student.emails.length > 0 ? new Date(student.emails[student.emails.length - 1].createdDate) : null,
          numberOfEmailsSent: student.emails.length,
        }),
      ) ?? ([] as InvitedNotLoggedStudentData[]),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.INVITED_STUDENTS(),
    });
  };

  return { invalidate, isLoading, isFetching, students: data ?? [] };
};

export interface InvitedNotLoggedStudentData {
  id: number;
  email: string;
  lastEmailSent: Date | null;
  numberOfEmailsSent: number;
}
